import type { PromoCodeProps } from './promoCode.queries';

export const urls = {
  promoCode: '/carts/validate_promo_code',
};

export const queryKeys = {
  promoCode: (params: PromoCodeProps) => [
    'promoCode',
    params.promoCode,
    params.reservationMode,
    params.uuid,
  ],
};
